import React, { useEffect, useState } from 'react'
import styles from './scss/churnpredication.module.scss';
import ApexBarChart from '../../components/custom_components/apexChartsTypes/barChart';
import paginationFactory from 'react-bootstrap-table2-paginator';
import BootstrapTable from 'react-bootstrap-table-next';
import DonutChart from '../../components/custom_components/apexChartsTypes/donutChart';
import { useSelector } from 'react-redux';
import { churnPredictionNlpData, getChurnPredictionOverallRlt, getChurnPredictionProbability, getChurnPredictionSegmentRlt } from '../../apiservice/aiPilot';
import Loaders from '../../components/loader/loader';
import { useDispatcher } from '../../custom_hooks/use_app_dispatch';
import { dashboardAction } from '../../store/slices/dashboard';
import WorktualModal from '../../components/custom_components/worktualModal';
import { churnPlotLycaNlpData, churnPredictionLycaNlpData, getLycaChurnPredictionOverallRlt, getLycaChurnPredictionProbability, getLycaChurnPredictionSegmentRlt } from '../../apiservice/aiLycaPilot';

const ChurnPrediction = () => {

    const dispatch = useDispatcher()
    const { moduledateFilter, churnPredictionNlp, churnPlotNlp } = useSelector((store: any) => store.dashboardReducer)
    const [loader, setLoader] = useState(false)
    const [datas, setData] = useState<any>([])
    const [churnResult, setChurnResult] = useState<any>([])
    const [series, setSeries] = useState<number[]>([]);
    const [labels, setLabels] = useState<string[]>([]);
    const [nlpData, setNlpData] = useState<any>(null);
    const { buyerNlpData } = useSelector((store: any) => store.dashboardReducer)
    const [showInsightsModal, setShowInsightsModal] = useState(false);
    useEffect(() => {
        const fetchNlpData = async () => {
            try {
                setLoader(true);

                const res = await churnPredictionLycaNlpData();
                if (res?.status === 200) {
                    setNlpData(res.data); // store API result
                    dispatch(dashboardAction.setChurnPrediction(res.data))
                }
            } catch (error) {
                console.error("Error fetching NLP data:", error);
            } finally {
                setLoader(false);
            }
        };
        fetchNlpData();
    }, [dispatch]);


    useEffect(() => {
        const fetchNlpData = async () => {
            try {
                setLoader(true);

                const res = await churnPlotLycaNlpData();
                if (res?.status === 200) {
                    dispatch(dashboardAction.setChurnPlotLyca(res.data))
                }
            } catch (error) {
                console.error("Error fetching NLP data:", error);
            } finally {
                setLoader(false);
            }
        };
        fetchNlpData();
    }, [dispatch]);


    const columns = [
        {
            dataField: "segement",
            text: "Segment",
            sort: true,
        },
        {
            dataField: "customerCount",
            text: "Customer Count",
            sort: true,
        },
        {
            dataField: "revenue",
            text: "Revenue (Kr)", // 👈 update header text if you want
            sort: true,
            formatter: (cell: number) => `${cell.toLocaleString()} Kr`, // 👈 pound + comma formatted
        },
        {
            dataField: "APRU",
            text: "ARPU (Kr)",
            sort: true,
            formatter: (cell: number) => `${cell.toLocaleString()} Kr`,
        },
    ];

    useEffect(() => {
        callApis(moduledateFilter)
    }, [moduledateFilter])

    const callApis = (moduledateFilter: any) => {

        if (!moduledateFilter?.fromYear || !moduledateFilter?.toYear) return
        const body = {
            domainId: null,
            fromYear: moduledateFilter?.fromYear ?? null,
            toYear: moduledateFilter?.toYear ?? null,
        }
        getLycaChurnPredictionOverallRltData(body)
        getLycaChurnPredictionProbabilityData(body)
        getLycaChurnPredictionSegmentRltData(body)

    }


    const getLycaChurnPredictionOverallRltData = async (body: any) => {
        try {
            setLoader(true);

            const res = await getLycaChurnPredictionOverallRlt(body);

            if (res?.data?.statusCode === 200) {
                const data = res.data.response;
                console.log('getChurnPredictionOverallRlt----', data)
                setChurnResult(data)
            }
        } catch (error) {
            console.error("Error fetching segmentation target data:", error);
        } finally {
            setLoader(false);
        }
    };

    const getLycaChurnPredictionProbabilityData = async (body: any) => {
        try {
            setLoader(true);

            const res = await getLycaChurnPredictionProbability(body);

            if (res?.data?.statusCode === 200) {
                const data = res.data.response;

                // If you want to exclude "overall likely to churn" from the chart
                const filteredData = data.filter(
                    (item: any) =>
                        item.segement.toLowerCase() !== "overall likely to churn"
                );
                // Map response to chart format
                setSeries(filteredData.map((item: any) => Number(item.percentage.toFixed(1))));
                setLabels(filteredData.map((item: any) => item.segement));
            }
        } catch (error) {
            console.error("Error fetching churn prediction probability data:", error);
        } finally {
            setLoader(false);
        }
    };


    const getLycaChurnPredictionSegmentRltData = async (body: any) => {
        try {
            setLoader(true);

            const res = await getLycaChurnPredictionSegmentRlt(body);

            if (res?.data?.statusCode === 200) {
                const apiData = res.data.response;

                // Add id and ensure numbers are safe
                const tableData = apiData.map((item: any, index: number) => ({
                    id: index + 1,
                    segement: item.segement,
                    customerCount: item.customerCount ?? 0,
                    revenue: item.revenue ?? 0,
                    APRU: item.APRU ? Number(item.APRU).toFixed(2) : "0.00",
                }));

                setData(tableData);
            }
        } catch (error) {
            console.error("Error fetching segmentation target data:", error);
        } finally {
            setLoader(false);
        }
    };



    return (
        <>
            {loader ? (
                <Loaders />
            ) : (
                <div className={styles.chrunpredicationsec}>
                    <h4 className={styles.paratxt}>Estimates the likelihood of churn for customers<br /> using predictive analysis.</h4>
                    <div className={styles.allotmentsecsegt}>
                        {/* Overall Likely to Churn */}
                        {/* <div
                            className={styles.altblocksegt}
                            style={{ background: "linear-gradient(180deg, #FFF 50%, #F5FFFC 100%)" }}
                        >
                            <p className={styles.altcount}>
                                {churnResult.find((item: any) => item.segement === "Overall likely to churn")?.customerCount.toLocaleString() ?? 0}
                            </p>
                            <div className={styles.altinfos}>
                                <p>Overall Likely to churn</p>
                                <span>At-risk customers needing retention.</span>
                            </div>
                        </div> */}

                        {/* Mostly Likely to Churn */}
                        <div
                            className={styles.altblocksegt}
                            style={{ background: "linear-gradient(180deg, #FFF 50%, #F5F5FF 100%)" }}
                        >
                            <p className={styles.altcount}>
                                {churnResult.find((item: any) => item.segement === "Most likely to churn")?.customerCount.toLocaleString() ?? 0}
                            </p>
                            <div className={styles.altinfos}>
                                <h4>Most likely to churn</h4>
                                <p>High risk—act now.</p>
                            </div>
                        </div>

                        {/* Fairly Likely to Churn */}
                        <div
                            className={styles.altblocksegt}
                            style={{ background: "linear-gradient(180deg, #FFF 50%, #FFFFF5 100%)" }}
                        >
                            <p className={styles.altcount}>
                                {churnResult.find((item: any) => item.segement === "Fairly likely to churn")?.customerCount.toLocaleString() ?? 0}
                            </p>
                            <div className={styles.altinfos}>
                                <h4>Fairly likely to churn</h4>
                                <p>Moderate risk—engage proactively.</p>
                            </div>
                        </div>

                        {/* Less Likely to Churn */}
                        <div
                            className={styles.altblocksegt}
                            style={{ background: "linear-gradient(180deg, #FFF 50%, #FFF5F5 100%)" }}
                        >
                            <p className={styles.altcount}>
                                {churnResult.find((item: any) => item.segement === "Less likely to churn")?.customerCount.toLocaleString() ?? 0}
                            </p>
                            <div className={styles.altinfos}>
                                <h4>Less likely to churn</h4>
                                <p>Low risk—keep nurturing.</p>
                            </div>
                        </div>
                    </div>

                    <div className={styles.chartandsummary}>
                        <div className={`${styles.clvchartwrapper}`}>
                            <div className={styles.clvwrapheader}>
                                <p className={styles.clvwrapheadertxt}>Churn Probability</p>
                                <span className={styles.clvwrpadesc}>Identify customers most likely to leave and act early with insights that drive retention.</span>
                            </div>

                            <div className={styles.clvwrapbody}>
                                <DonutChart
                                    key={JSON.stringify(series) + JSON.stringify(labels)}
                                    series={series}
                                    labels={labels}
                                    colors={["#c6c91aff","#D62728", "#2CA02C"]}
                                    toastSuffix='%'
                                />
                                {/* <DonutChart series={series} labels={labels} /> */}
                                <div className={styles.labelsgrp}>
                                    {labels.map((label, index) => {
                                        const colors = ["#c6c91aff","#D62728", "#2CA02C"];
                                        // Add more colors if API returns more segments

                                        return (
                                            <div key={index} className={styles.indvidualchartlabel}>
                                                <span
                                                    className={styles.dot}
                                                    style={{ backgroundColor: colors[index % colors.length] }}
                                                ></span>
                                                <p>{label}</p>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                            <div className={styles.clvwrapfooter}>
                                <div className='insightsbtn'>AI Insights</div>
                                <div
                                    className={styles.clvwrapfttxt}
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            churnPlotNlp?.message?.[1]?.concise_summary?.replace(/[-_,|]+/g, "") || "",
                                    }}
                                />
                                <div
                                    className={styles.seemoretxt}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setShowInsightsModal(true);
                                    }}
                                >
                                    See more
                                </div>
                            </div>
                        </div>
                        <div className={styles.aisummarysec}>
                            <div className={styles.aisummarywrapsec}>
                                <h4 className={styles.aisumheading}>AI Summary</h4>
                                <div
                                    className={styles.clvwrapfttxt}
                                    dangerouslySetInnerHTML={{
                                        __html: (churnPredictionNlp?.message || "")
                                            .replace(/[-_,|]+/g, "") // remove -, _, , and |
                                    }}
                               />


                            </div>
                        </div>
                    </div>
                    <div className='desktoptable'>
                        <BootstrapTable
                            keyField="id"
                            data={datas}
                            columns={columns}
                        // pagination={paginationFactory(tableOpt)}
                        // noDataIndication={<NoTableData />}
                        />
                    </div>
                </div>
            )}
            {/* Modal */}
            <WorktualModal
                show={showInsightsModal}
                onClose={() => {
                    setShowInsightsModal(false);
                    dispatch(dashboardAction.setSummary({}));
                }}
            >
                <div className={styles.insightsviewmdltext}>
                    <span className="insightsbtn" style={{ marginBottom: "12px" }}>
                        AI Insights
                    </span>
                    {churnPlotNlp?.message?.length > 0 ? (
                        <p
                            className={styles.clvmdltxt}
                            dangerouslySetInnerHTML={{
                                __html:
                                    churnPlotNlp.message[0]?.actual_summary?.replace(/[-_,|]+/g, "") ||
                                    "",
                            }}
                        />
                    ) : (
                        "NO NLP DATA"
                    )}
                </div>
            </WorktualModal>


        </>
    )
}

export default ChurnPrediction
